export const GET_DASHBOARD = 'GET_DASHBOARD';
export const RESET_DASHBOARD = 'RESET_DASHBOARD';



// WEBPACK FOOTER //
// src/containers/dashboard/constants.js